jQuery(document).ready(function ($) {
    var $mobileNavButton = $(".mobile-nav-button");
    var $mobileNav = $(".nav-closed");

    function setMobileMenuState(isOpen) {
        $mobileNav.toggleClass("open", isOpen);
        $(".bar1").toggleClass("change", isOpen);
        $(".bar2").toggleClass("change", isOpen);
        $(".bar3").toggleClass("change", isOpen);
        $("body").toggleClass("mobile-nav-open", isOpen);
        $mobileNavButton.attr("aria-expanded", isOpen ? "true" : "false");
        $mobileNavButton.attr("aria-label", isOpen ? "Close menu" : "Open menu");

        if (!isOpen) {
            $('.has-mega-menu').removeClass('mega-menu-open');
            $('.has-mega-menu > a').attr('aria-expanded', 'false');
        }
    }

    //burger icon js opens nav and changes burger to cross
    $('body').click(function (e) {
        var target = $(e.target),
            article;

        if (target.is('.mobile-nav-button') || target.is('.bar1') || target.is('.bar2') || target.is('.bar3') || target.closest('.nav-closed').length) {
            return;
        } else {

            if ($mobileNav.hasClass("open")) {
                setMobileMenuState(false);
            }
        }

    });

    $mobileNavButton.click(function () {
        setMobileMenuState(!$mobileNav.hasClass("open"));
    })

    $mobileNav.on('click', 'a', function () {
        if (window.innerWidth >= 992) return;
        setMobileMenuState(false);
    })

    var headerElement = document.getElementById('header');
    var isAboutPage = document.body.classList.contains('page-template-about');
    var aboutHeaderScrolled = window.scrollY >= 50;
    var headerScrollTicking = false;

    function updateHeaderState() {
        var scrollTop = window.scrollY || window.pageYOffset || 0;

        if (isAboutPage) {
            // A small hysteresis band prevents state flicker around the 50px threshold.
            if (!aboutHeaderScrolled && scrollTop >= 56) {
                aboutHeaderScrolled = true;
            } else if (aboutHeaderScrolled && scrollTop <= 44) {
                aboutHeaderScrolled = false;
            }

            headerElement.classList.toggle('header--scrolled', aboutHeaderScrolled);
            // Retain the legacy class for existing header geometry and menu rules.
            headerElement.classList.toggle('scrolled', aboutHeaderScrolled);
        } else {
            headerElement.classList.toggle('scrolled', scrollTop > 24);
            headerElement.classList.remove('header--scrolled');
        }
    }

    function requestHeaderStateUpdate() {
        if (headerScrollTicking) return;

        headerScrollTicking = true;
        window.requestAnimationFrame(function () {
            updateHeaderState();
            headerScrollTicking = false;
        });
    }

    updateHeaderState();
    window.addEventListener('scroll', requestHeaderStateUpdate, { passive: true });

    //header spacing
    let headerHeight = $('#header').outerHeight();

    $('.header-spacing').css('padding-top', `${headerHeight}px`)

    // Check window width and add class to #header for tactile or desktop.
    $(window).on('resize', function () {
        if (window.innerWidth < 992) {
            if (!$('#header').hasClass('tactile')) {
                $('#header').addClass('tactile');
                $('#header').removeClass('desktop');
            }
        } else {
            if (!$('#header').hasClass('desktop')) {
                $('#header').addClass('desktop');
                $('#header').removeClass('tactile');
            }
        }
    }).resize();

    // "New Launches" dropdown: on mobile, tapping the trigger toggles the
    // mega menu open/closed instead of navigating. On desktop it opens on hover.
    var $megaParent = $('.has-mega-menu');
    var $megaTrigger = $megaParent.find('> a');

    $megaTrigger.on('click', function (e) {
        if (window.innerWidth >= 992) return; // desktop: let hover + normal link work
        e.preventDefault();
        var $parent = $(this).closest('.has-mega-menu');
        var isOpen = $parent.toggleClass('mega-menu-open').hasClass('mega-menu-open');
        $(this).attr('aria-expanded', isOpen ? 'true' : 'false');
    });

});
